import { useState } from 'react';
import { record } from '@solimat/solimat-web-endpoint';

const useUpdateSolicitudCATAFuegoByID = () => {
    const [loadingUpdateSolicitudCATAFuegoById, setLoadingUpdateSolicitudCATAFuegoById] = useState(false);
    const [successUpdateSolicitudCATAFuegoById, setSuccessUpdateSolicitudCATAFuegoById] = useState(false);
    const [errorUpdateSolicitudCATAFuegoById, setErrorUpdateSolicitudCATAFuegoById] = useState(null);
    const [dataUpdateSolicitudCATAFuegoById, setDataUpdateSolicitudCATAFuegoById] = useState(null);

    const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || '';
    const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || '';
    const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

    const updateSolicitudCATAFuegoById = async (userId: string, formId: string, data: any, callback?: (data: any) => void) => {
        setLoadingUpdateSolicitudCATAFuegoById(true);
        setSuccessUpdateSolicitudCATAFuegoById(false);
        setErrorUpdateSolicitudCATAFuegoById(null);

        try {
            const response = await apiRecord.updateSolicitudCataFmIncendioByID(userId, formId, data);
            setSuccessUpdateSolicitudCATAFuegoById(true);
            setDataUpdateSolicitudCATAFuegoById(response.data);
            callback?.(response.data);
            return response.data;
        } catch (error: any) {
            const responseData = error?.response?.data;
            setErrorUpdateSolicitudCATAFuegoById(responseData || error?.message || 'Error');
            throw error;
        } finally {
            setLoadingUpdateSolicitudCATAFuegoById(false);
        }
    };

    return {
        updateSolicitudCATAFuegoById,
        loadingUpdateSolicitudCATAFuegoById,
        successUpdateSolicitudCATAFuegoById,
        errorUpdateSolicitudCATAFuegoById,
        dataUpdateSolicitudCATAFuegoById,
    };
};

export default useUpdateSolicitudCATAFuegoByID;